import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';

export interface ShopOption {
    id: number;
    name: string;
}

export const useShopsDropdown = () => {
    const httpClient = createHttpClient(apiClientWH);

    const { data, isLoading } = useQuery({
        queryKey: ['shops-dropdown'],
        queryFn: async () => {
            try {
                const response = await httpClient.get<any>('/shops', { per_page: 100 });
                // La API puede devolver un objeto con data o directamente un array
                const shops = response?.data || response || [];
                return shops.map((shop: any) => ({
                    id: shop.id,
                    name: shop.name,
                })) as ShopOption[];
            } catch (error) {
                console.error('Error loading shops:', error);
                return [];
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutos
        gcTime: 10 * 60 * 1000, // 10 minutos
    });

    return {
        shops: data ?? [],
        isLoading,
    };
};

